module.exports = __webpack_public_path__ + "img/icon_map_38_on_100.bf2f30aa.png";